/**
 * 只能同步执行操作
 * 通过提交mutations的类型的方式使用 在vue组件中可以这样使用
 * store.commit(this.$mutationTypes.SET_USER, user = {})
 * @type {{}}
 */
import * as types from './mutation-types'

const mutations = {
  [types.SET_USERLOGINEDINFO] (state, info) {
    state.userLoginedInfo = info
  },
  [types.SET_REGISTSTEP] (state, info) {
    state.registStep = info
  },
  [types.SET_WORKDYMENUS] (state, info) {
    console.log(info,"infooooo")
    state.workDynamicsmEenus = info
  },
  [types.SET_TESTEVALMENUS] (state, info) {
    console.log(info,"infooooo")
    state.testEvaluationMenu = info
  }
}
export default mutations



// WEBPACK FOOTER //
// ./src/store/mutations.js